<template>
  <div>
    <HeaderPage>
      <br>
      <h1 class="mt-4 text-center">Immobilisations</h1>

      <!-- Bouton pour créer une nouvelle immobilisation -->
      <div class="text-center">
        <button @click="openCreateModal" class="btn btn-primary mb-3 create-article-btn">
          <i class="fas fa-plus"></i> Créer une immobilisation
        </button>
      </div>

      <!-- Barre de recherche -->
      <div class="text-center mb-3">
        <input
          type="text"
          v-model="searchTerm"
          placeholder="Rechercher une article"
          class="form-control"
          style="max-width: 300px; display: inline-block;"
        />
      </div>


      <!-- Tableau des articles -->
      <div class="table-responsive mt-4 mx-auto">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Nom de l'article</th>
              <th>Description</th>
              <th>Quantité</th>
              <th>Prix unitaire (en Ariary)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in filteredArticles" :key="article.id">
              <td>{{ article.nom_article }}</td>
              <td>{{ article.description_article }}</td>
              <td>{{ article.quantite }}</td>
              <td style="text-align: right;">{{ formatPrix(article.prix) }}</td>
              <td>
                <a href="#" @click.prevent="editArticle(article)" class="edit-btn">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" @click.prevent="deleteArticle(article)" class="delete-btn">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal pour créer un nouvel article -->
      <div v-if="showCreateModal">
        <div
          ref="createModalRef"
          class="modal fade"
          id="createModal"
          tabindex="-1"
          aria-labelledby="createModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="createModalLabel">Créer un nouvel article</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="closeCreateModal"
                ></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="submitCreateArticle">
                  <div class="mb-3">
                    <label for="nomArticle" class="form-label">Nom de l'article :</label>
                    <input
                      type="text"
                      id="nomArticle"
                      class="form-control"
                      v-model="newArticle.nom_article"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="descriptionArticle" class="form-label">Description :</label>
                    <textarea
                      id="descriptionArticle"
                      class="form-control"
                      v-model="newArticle.description_article"
                      required
                    ></textarea>
                  </div>
                  <div class="mb-3">
                    <label for="quantite" class="form-label">Quantité :</label>
                    <input
                      type="number"
                      id="quantite"
                      class="form-control"
                      v-model="newArticle.quantite"
                      min="1"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="prix" class="form-label">Prix (en Ariary) :</label>
                    <input
                      type="number"
                      id="prix"
                      class="form-control"
                      v-model="newArticle.prix"
                      min="0"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="categorie" class="form-label">Catégorie :</label>
                    <select v-model="newArticle.categorie_id" class="form-control" required>
                      <option v-for="category in categories" :key="category.id" :value="category.id">
                        {{ category.nom_categorie }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="image" class="form-label">Image :</label>
                    <input
                      type="file"
                      id="image"
                      class="form-control"
                      @change="handleFileUpload"
                      accept="image/*"
                      required
                    />
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">Créer</button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-bs-dismiss="modal"
                      @click="closeCreateModal"
                    >
                      Annuler
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal pour modifier un article -->
      <div v-if="selectedArticle">
        <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">Modifier l'article</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="cancelEdit"
                ></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="submitEdit">
                  <div class="mb-3">
                    <label for="nomArticleEdit" class="form-label">Nom de l'article :</label>
                    <input
                      type="text"
                      id="nomArticleEdit"
                      class="form-control"
                      v-model="selectedArticle.nom_article"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="descriptionArticleEdit" class="form-label">Description :</label>
                    <textarea
                      id="descriptionArticleEdit"
                      class="form-control"
                      v-model="selectedArticle.description_article"
                      required
                    ></textarea>
                  </div>
                  <div class="mb-3">
                    <label for="quantiteEdit" class="form-label">Quantité :</label>
                    <input
                      type="number"
                      id="quantiteEdit"
                      class="form-control"
                      v-model="selectedArticle.quantite"
                      min="1"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="prixEdit" class="form-label">Prix (en Ariary) :</label>
                    <input
                      type="number"
                      id="prixEdit"
                      class="form-control"
                      v-model="selectedArticle.prix"
                      min="0"
                      required
                    />
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">Enregistrer</button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-bs-dismiss="modal"
                      @click="cancelEdit"
                    >
                      Annuler
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeaderPage>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';
import { ref, onMounted, nextTick, computed } from "vue";
import axios from "axios";
import HeaderPage from './components/HeaderPage.vue';

export default {
  components: {
    HeaderPage,
  },
  methods: {
    formatPrix(valeur) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'decimal',
        minimumFractionDigits: 0
      }).format(valeur);
    }
  },
  setup() {
    const articles = ref([]);
    const selectedArticle = ref(null);
    const showCreateModal = ref(false);
    const searchTerm = ref("");
    const newArticle = ref({
      nom_article: "",
      description_article: "",
      quantite: 0,
      prix: 0,
      categorie_id: null,
      image_article: null,
    });
    const categories = ref([]);
    const createModalRef = ref(null);

    // Computed pour filtrer les articles par nom
    const filteredArticles = computed(() => {
      if (!searchTerm.value) {
        return articles.value;
      }
      return articles.value.filter(article =>
        article.nom_article.toLowerCase().includes(searchTerm.value.toLowerCase())
      );
    });

    // Récupérer les articles
    async function fetchArticles() {
      try {
        const token = localStorage.getItem("token");
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/users/articles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        articles.value = response.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des articles :", error.response?.data || error.message);
      }
    }

    // Récupérer les catégories
    async function fetchCategories() {
      try {
        const token = localStorage.getItem("token");
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/categories`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        categories.value = response.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des catégories :", error.response?.data || error.message);
      }
    }

    // Ouvrir le modal de création
    function openCreateModal() {
      showCreateModal.value = true;
      nextTick(() => {
        if (createModalRef.value) {
          const modal = new bootstrap.Modal(createModalRef.value);
          modal.show();
        } else {
          console.error("L'élément modal n'a pas été trouvé via le ref.");
        }
      });
    }

    // Fermer le modal de création
    function closeCreateModal() {
      showCreateModal.value = false;
      newArticle.value = {
        nom_article: "",
        description_article: "",
        quantite: 0,
        prix: 0,
        categorie_id: null,
        image_article: null,
      };
    }

      

    // Gérer l'upload de fichier
    function handleFileUpload(event) {
      newArticle.value.image_article = event.target.files[0];
    }

    // Soumettre la création d'un nouvel article
    async function submitCreateArticle() {
      const formData = new FormData();
      formData.append("nom_article", newArticle.value.nom_article);
      formData.append("description_article", newArticle.value.description_article);
      formData.append("quantite", newArticle.value.quantite);
      formData.append("prix", newArticle.value.prix);
      formData.append("categorie_id", newArticle.value.categorie_id);
      formData.append("image_article", newArticle.value.image_article);

      try {
        const token = localStorage.getItem("token");
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.post(`${API_URL}/api/user/insertArticle`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(response.data.message);
        closeCreateModal();
        fetchArticles(); // Rafraîchir la liste des articles
      } catch (error) {
        console.error("Erreur lors de la création de l'article :", error.response?.data || error.message);
      }
    }

    // Modifier un article
    function editArticle(article) {
      selectedArticle.value = { ...article };
      nextTick(() => {
        const modalElement = document.getElementById('editModal');
        if (modalElement) {
          const modal = new bootstrap.Modal(modalElement);
          modal.show();
        } else {
          console.error("L'élément du modal d'édition n'a pas été trouvé.");
        }
      });
    }

    // Soumettre les modifications
    async function submitEdit() {
      try {
        const token = localStorage.getItem("token");
        const { id } = selectedArticle.value;
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.put(`${API_URL}/api/user/modifyArticle/${id}`, selectedArticle.value, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response.data.message);
        selectedArticle.value = null;
        fetchArticles();
      } catch (error) {
        console.error("Erreur lors de la modification :", error.response?.data || error.message);
      }
    }

    // Supprimer un article
    async function deleteArticle(article) {
      try {
        const token = localStorage.getItem("token");
        const { id } = article;
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.delete(`${API_URL}/api/articles/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response.data.message);
        fetchArticles();
      } catch (error) {
        console.error("Erreur lors de la suppression de l'article :", error.response?.data || error.message);
      }
    }

    // Annuler la modification
    function cancelEdit() {
      selectedArticle.value = null;
    }

    // Charger les articles et catégories au montage
    onMounted(() => {
      fetchArticles();
      fetchCategories();
    });

    return {
      articles,
      filteredArticles,
      selectedArticle,
      showCreateModal,
      newArticle,
      categories,
      createModalRef,
      searchTerm,
      openCreateModal,
      closeCreateModal,
      handleFileUpload,
      submitCreateArticle,
      editArticle,
      submitEdit,
      deleteArticle,
      cancelEdit,
    };
  },
};
</script>

<style scoped>
/* Styles généraux */
.home-container {
  margin-left: 250px;
  padding: 20px;
  padding-top: 60px;
}

/* Boutons Modifier et Supprimer */
.edit-btn,
.delete-btn {
  padding: 8px 15px;
  border: 1px solid #ccc;
  background-color: transparent;
  color: #007bff;
  cursor: pointer;
  transition: color 0.3s ease, border-color 0.3s ease;
  font-size: 18px;
}

.edit-btn:hover {
  color: #0056b3;
  border-color: #0056b3;
}

.delete-btn {
  color: #dc3545;
}

.delete-btn:hover {
  color: #c82333;
  border-color: #c82333;
}

.fas {
  font-size: 18px;
}

/* Bouton "Créer un article" avec largeur réduite */
.create-article-btn {
  width: 180px; /* Ajustez la valeur selon vos besoins */
}

/* Tableau centré */
.table-responsive {
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
}

/* Style personnalisé pour le modal */
.modal-dialog {
  max-width: 90%;
  width: 500px;
  margin: 10px auto;
}

.modal-content {
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  padding: 15px;
}

@media (max-width: 768px) {
  .modal-dialog {
    width: 100%;
    margin: 10px;
  }
  .modal-content {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .modal-dialog {
    max-width: 100%;
  }
  .modal-content {
    font-size: 0.9rem;
  }
}
</style>
